import React from "react";
import Texts from "../../../utils/lang-utils";
import { redirectTo } from "../../../utils/window-utils";
import { config } from "../../../utils/config";
import "../assets/scss/OnboardedModal.css";

const AlreadyOnboardedModal = (props) => {
  return (
    <div className="onboarded-modal">
      <div className="modal-container">
        <div className="onboarded-modal-icon">
          <i className="fa fa-exclamation"></i>
        </div>
        <div className="onboarded-modal-text">
          <h2>{Texts.onboarding.alreadyReg}</h2>
          <h3>{Texts.onboarding.alreadyDesc}</h3>
        </div>
        <button className="onboarded-modal-btn" onClick={() => redirectTo(`${config.AdminUrl}`)}>
          {Texts.onboarding.login}
        </button>
        </div>
    </div>
  );
};

export default AlreadyOnboardedModal;
